import React, { Fragment, useEffect } from "react";
import { Col, FormGroup, Label } from "reactstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import DropdownList from "react-widgets/DropdownList";
import classNames from "classnames";
import { FaRegStar, FaStar } from "react-icons/fa";
import { useAbsentsContext } from "Pages/Melder/Indienen/AbsentsContext";
import { useWizardContext } from "Pages/Melder/Indienen/WizardContext";

const BasicInformation = ({
    formikProps,
    formDataState,
    setFormDataState,
    isDisabled,

}) => {
    const { setFieldValue, errors, values } = formikProps;
    const organisationId = values.organisationId;
    const { absentsData, handleLikeStatus, setParams } = useAbsentsContext();
    const { codeListData, schools, groupsData, usersData, getSchoolsByCommunityId, organizationsList, getOrganizationsList } = useWizardContext();

    // autoselect for organisation
    useEffect(() => {
        if (usersData.length === 1) {
            setFieldValue('organisationId', usersData[0].iCommunityId);
            getSchoolsByCommunityId(usersData[0].iCommunityId);
        }
    }, [usersData]);

    // autoselect for school
    useEffect(() => {
    if (schools.length === 1) {
        setFieldValue('schoolId', schools[0].iSchoolId);
    }
    }, [schools]);
   

    return (
       
<Fragment>
    <FormGroup row>
        <Label xs={12} lg={3}>
            Organisatie *
        </Label>
        <Col xs={12} lg={7} className="me-lg-4">
            <DropdownList dataKey='iCommunityId' textField='name'
                placeholder="Selecteer organisatie"
                className={classNames({ "border border-danger rounded": errors.organisationId && isDisabled })}
                onChange={(nextValue) => {
                    const isOrgChanged =
                        values.organisationId &&
                        values.organisationId !== nextValue.iCommunityId;

                    getSchoolsByCommunityId(nextValue.iCommunityId);
                    setFieldValue("organisationId", nextValue.iCommunityId);

                    if (isOrgChanged) {
                        setFieldValue("schoolId", "");
                        setFieldValue("absentId", "");
                        setFieldValue("codeId", "");
                        setFieldValue("groupsId", []);

                        setFormDataState(prev => ({
                            ...prev,
                            school: "",
                            absent: "",
                            code: "",
                            groups: [],
                            organisation: nextValue.name,
                        }));
                    }
                }}
                name="organisationId"
                data={organizationsList}
                value={formikProps.values.organisationId}
                required={true}
            />
            {errors.organisationId && isDisabled && <div className="text-danger">{errors.organisationId}</div>}
        </Col>
    </FormGroup>

    <FormGroup row>
        <Label xs={12} lg={3}>
            School *
        </Label>
        <Col xs={12} lg={7} className="me-lg-4">
            <DropdownList dataKey='iSchoolId' textField='vSchoolName'
                placeholder="Selecteer school"
                className={classNames({ "border border-danger rounded": errors.schoolId && isDisabled })}
                onChange={(nextValue) => {
                    setParams({
                        schoolId: nextValue.iSchoolId,
                        communityId: values.organisationId
                    });
                    setFieldValue('schoolId', nextValue.iSchoolId)
                    setFormDataState({ ...formDataState, school: nextValue.vSchoolName })
                }}
                name="schoolId"
                data={schools}
                value={formikProps.values.schoolId}
            />
            {errors.schoolId && isDisabled && <div className="text-danger">{errors.schoolId}</div>}
        </Col>
    </FormGroup>

    <FormGroup row>
        <Label xs={12} lg={3}>
            Afwezige
        </Label>
        <Col xs={12} lg={7} className="me-lg-4">
            <Typeahead id="iAdminId" key={values.organisationId} labelKey="formatted" multiple={false} options={absentsData.map((item) => ({
                ...item,
                formatted: `${item.name || ''} ${item.birthdate ? `- ${item.birthdate}` : ''} ${item.city ? `- ${item.city}` : ''}`
            }))}
                placeholder="Selecteer afwezige" name="absentId"
                defaultInputValue={formDataState.absent}
                onChange={e => {
                    if (e.length !== 0) {
                        setFieldValue('absentId', e[0].iAdminId)
                        setFormDataState({ ...formDataState, absent: e[0].name })
                    } return;
                }}
                renderMenuItemChildren={(option, props) => {
                    const isLiked = option.bSelected == 1 ? true : false;
                    return (
                        <div className="d-flex justify-content-between align-items-start w-100 afwezige-dropdown">
                            <span>{option.formatted}</span>
                            <span
                                className="d-flex justify-content-center"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handleLikeStatus(option.iAdminId, values.schoolId, isLiked);
                                }}
                            >
                                {isLiked ? (
                                    <FaStar color="#076396" size={20} />
                                ) : (
                                    <FaRegStar size={20} />
                                )}
                            </span>
                        </div>
                    );
                }}
            />
        </Col>
    </FormGroup>

    <FormGroup row>
        <Label xs={12} lg={3}>
            Code *
        </Label>
        <Col xs={12} lg={7} className="me-lg-5">
            <DropdownList dataKey='iCodeId' textField='codeName'
                placeholder="Selecteer code afwezigheid" name="codeId"
                className={classNames({ "border border-danger rounded": errors.codeId && isDisabled })}
                onChange={e => {
                    setFieldValue('codeId', e.iCodeId)
                    setFormDataState({ ...formDataState, code: e.codeName })
                }}
                data={codeListData}
                value={formDataState.code}
                renderListItem={({ item }) => (
                    <div>
                        <p className="m-0">{item.vCode}</p>
                        <p className="m-0">{item.vCodeValue}</p>
                    </div>
                )}
            />
            {errors.codeId && isDisabled && <div className="text-danger">{errors.codeId}</div>}
        </Col>
    </FormGroup>

    <FormGroup row>
        <Label xs={12} lg={3}>
            Functies *
        </Label>
        <Col xs={12} lg={7} className="me-lg-5">
            <Typeahead id="iSubGroupId" labelKey="vGroup" multiple={true}
                options={groupsData} placeholder="Selecteer functies" name="groupsId"
                selected={
                    groupsData.filter(group =>
                        formDataState.groups.includes(group.vGroup)
                    )
                }
                className={classNames({ "border border-danger rounded": errors.groupsId && isDisabled })}
                onChange={e => {
                    setFieldValue('groupsId', e.sort((x, y) => x.iSubGroupId - y.iSubGroupId).map(e => e.iSubGroupId))
                    setFormDataState({ ...formDataState, groups: e.map(group => group.vGroup) })
                }}
            />
            {errors.groupsId && isDisabled && <div className="text-danger">{errors.groupsId}</div>}
        </Col>
    </FormGroup>
</Fragment>

    )
};

export default BasicInformation;